import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

interface ScorePointsProps {
    value: number;
    maxValue: number;
}

const ScorePoints: React.FC<ScorePointsProps> = (props) => {
    const { value, maxValue } = props;

    return (
        <div className="flex-center">
            <div className="relative flex">
                <CircularProgress variant="determinate" size={100} value={100} color="inherit" style={{ color: '#ccc' }} />
                <CircularProgress
                    variant="determinate"
                    size={100}
                    value={(value / maxValue) * 100}
                    style={{ position: 'absolute', left: 0, top: 0 }}
                />
                <div
                    className="flex-center"
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                    }}>
                    <div className="top-title">{value}</div>
                </div>
            </div>
        </div>
    );
};

export default ScorePoints;
